import React, { useState } from "react";
import "./PasswordInput.css"; // Importando o arquivo CSS para estilização

const PasswordInput = ({ value, onChange }) => {
    const [showPassword, setShowPassword] = useState(false);

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };
    const handleChange = (e) => {
        const newValue = e.target.value;
        onChange(newValue);
    };

    return (
        <div className="password-input-container">
            <label>
                Senha:
                <div className="password-input-wrapper">
                    <input
                        type={showPassword ? "text" : "password"}
                        value={value}
                        onChange={handleChange}
                        required
                        
                ></input>
                    <span className="password-toggle" onClick={togglePasswordVisibility}>
                        {showPassword ? <i class="uil uil-eye"></i> : <i class="uil uil-eye-slash"></i>}
                    </span>
                </div>
            </label>
        </div>
    );
};

export default PasswordInput;
